import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useMemo } from 'react';
import './styles.scss';

const AloSidebar = ({
  anchor = 'right',
  headerBorder = false,
  onClose,
  title,
  visible,
  desktopWidth = 560,
  mobileWidth = '100%',
  children,
  wrapperClass = '',
  postHeader,
}: AloSidebarProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)', { noSsr: true });
  const width = isMobile ? mobileWidth : desktopWidth;

  useEffect(() => {
    if (visible) {
      document.body.classList.add('locked');
      document.body.classList.add('alo-sidebar-open');
    } else {
      document.body.classList.remove('locked');
      document.body.classList.remove('alo-sidebar-open');
    }
  }, [visible]);

  const inlineTransitionStyle = useMemo(() => {
    const sidebarWidth = isNaN(Number(width)) ? width : `${width}px`;
    return {
      width: sidebarWidth,
      transform: `translateX(${anchor === 'left' ? '-' : ''}${sidebarWidth})`,
      WebkitTransition: `translateX(${sidebarWidth})`,
    };
  }, [width, anchor]);

  return (
    <>
      <div
        className={`alo-overlay ${!visible ? 'alo-overlayHidden' : ''} ${visible ? 'alo-overlayOpen' : ''}`}
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className={`alo-sidebar ${wrapperClass} ${!visible ? 'hidden' : ''} ${visible ? 'animate' : ''} ${anchor}`}
        style={visible ? {} : inlineTransitionStyle}
      >
        <div style={{ width }} className={`alo-sidebar-header ${headerBorder ? 'bordered-header' : ''}`}>
          <h4 className="h4 uppercase sidebar-title" onClick={(e) => onClose(e)}>
            {title}
          </h4>
          <div className="post-header">{postHeader}</div>
          <div role="button" className="alo-sidebar-close" onClick={(e) => onClose(e)} />
        </div>
        <div className="alo-sidebar-body" style={{ width }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default AloSidebar;

interface AloSidebarProps {
  anchor?: 'top' | 'right' | 'bottom' | 'left';
  headerBorder?: boolean;
  wrapperClass?: string;
  onClose: (e?: React.MouseEvent) => void;
  title: string;
  visible: boolean;
  desktopWidth?: number | string;
  mobileWidth?: number | string;
  children: React.ReactNode;
  postHeader?: React.ReactNode;
  stickyFooter?: React.ReactNode;
}
